import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M9 9l.01 0","key":"svg-1"}],["path",{"d":"M15 9l.01 0","key":"svg-2"}],["path",{"d":"M8 13a4 4 0 1 0 8 0h-8","key":"svg-3"}]]

const IconMoodHappy = createReactComponent('outline', 'mood-happy', 'MoodHappy', __iconNode);

export default IconMoodHappy;